import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import About from './pages/About';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';   // ← NEW
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import ShopDetail from './pages/ShopDetail';
import Cart from './pages/Cart';
import { ShopProvider } from './context/ShopContext';
import AccountPage from "./pages/AccountPage";
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminLogin     from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import RequireAdmin   from './pages/admin/RequireAdmin';
import AdminShopProducts from './pages/admin/AdminShopProducts';
import AdminShopCategories from './pages/admin/AdminShopCategories';
import AdminShopOrders from './pages/admin/AdminShopOrders';
import AdminShopCoupons from './pages/admin/AdminShopCoupons';
import AdminBankingDetails from './pages/admin/AdminBankingDetails'; 
import AdminCustomers from './pages/admin/AdminCustomers'; 
import AdminSlideshow from './pages/admin/AdminSlideshow'; 
import AdminServices from './pages/admin/AdminServices';  
import AdminProducts from './pages/admin/AdminProducts';  
import AdminFaq from './pages/admin/AdminFaq'; 
import AdminGallery from './pages/admin/AdminGallery';  
import AdminVideos from './pages/admin/AdminVideos';  
import AdminNavbar from './pages/admin/AdminNavbar';  
import AdminCompanyContact from './pages/admin/AdminCompanyContact';  
import AdminAboutUs from './pages/admin/AdminAboutUs';   
import AdminTeam from './pages/admin/AdminTeam';   
import AdminTestimonials from './pages/admin/AdminTestimonials';   
import AdminSocialLinks from './pages/admin/AdminSocialLinks';
import AdminUsers from './pages/admin/AdminUsers';  
import AdminLogos from './pages/admin/AdminLogos';   
import AdminCustomerWishlist from './pages/admin/AdminCustomerWishlist';   

function ComingSoon({ title }) {
  return (
    <div style={{
      minHeight: '60vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      paddingTop: '140px', gap: '16px', fontFamily: 'sans-serif',
    }}>
      <h1 style={{ fontSize: '2rem', color: '#1e1e1f' }}>{title}</h1>
      <p style={{ color: '#888' }}>Page coming soon.</p>
    </div>
  );
}

const withLayout = (Component, props = {}) => (
  <>
    <Navbar />
    <Component {...props} />
    <Footer />
  </>
);

const withShopLayout = (Component, props = {}) => (
  <>
    <Navbar />
    <Component {...props} />
    <Footer />
  </>
);

export default function App() {
  return (
    <BrowserRouter>
      <ShopProvider>
        <Routes>

          {/* ── Main site routes ── */}
          <Route path="/"               element={withLayout(Home)} />
          <Route path="/about-us"          element={withLayout(About)} />
          <Route path="/services"       element={withLayout(Services)} />

          <Route path="/services/:slug" element={withLayout(ServiceDetail)} />
          <Route path="/products/:slug" element={withLayout(ProductDetail)} />

          <Route path="/projects"       element={withLayout(ComingSoon, { title: 'Projects' })} />
          <Route path="/portfolio"      element={withLayout(Portfolio)} />
          <Route path="/products"       element={withLayout(Products)} />
          <Route path="/team"           element={withLayout(ComingSoon, { title: 'Our Team' })} />
          <Route path="/contact"        element={withLayout(Contact)} />

          {/* ── Shop routes ── */}
          <Route path="/shop"       element={withShopLayout(Shop)} />
          <Route path="/shop/:slug" element={withShopLayout(ShopDetail)} />
          <Route path="/cart"       element={withShopLayout(Cart)} />

          {/* ── Auth routes ── */}
          <Route path="/login"    element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* ── Account routes ── */}
          <Route path="/account/:section" element={<AccountPage />} />
          <Route path="/account"          element={<Navigate to="/account/orders" replace />} />
          <Route path="/:slug" element={withLayout(ServiceDetail)} />

          <Route path="/admin/login"     element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="/admin/shop/products" element={<RequireAdmin><AdminShopProducts /></RequireAdmin>} />
          <Route path="/admin/shop/categories" element={<RequireAdmin><AdminShopCategories /></RequireAdmin>} />
          <Route path="/admin/shop/orders" element={<RequireAdmin><AdminShopOrders /></RequireAdmin>} />
          <Route path="/admin/shop/coupons" element={<RequireAdmin><AdminShopCoupons /></RequireAdmin>} />
          <Route path="/admin/shop/banking-details" element={<RequireAdmin><AdminBankingDetails /></RequireAdmin>} /> 
          <Route path="/admin/crm/customers" element={<RequireAdmin><AdminCustomers /></RequireAdmin>} />
          <Route path="/admin/content/slideshow" element={<RequireAdmin><AdminSlideshow /></RequireAdmin>} />
          <Route path="/admin/content/services" element={<RequireAdmin><AdminServices /></RequireAdmin>} /> 
          <Route path="/admin/content/products" element={<RequireAdmin><AdminProducts /></RequireAdmin>} /> 
          <Route path="/admin/content/faq" element={<RequireAdmin><AdminFaq /></RequireAdmin>} />  
          <Route path="/admin/content/gallery" element={<RequireAdmin><AdminGallery /></RequireAdmin>} />  
          <Route path="/admin/content/videos" element={<RequireAdmin><AdminVideos /></RequireAdmin>} />   
          <Route path="/admin/content/navbar" element={<RequireAdmin><AdminNavbar /></RequireAdmin>} />   
          <Route path="/admin/settings/company-contact" element={<RequireAdmin><AdminCompanyContact /></RequireAdmin>} /> 
          <Route path="/admin/settings/about" element={<RequireAdmin><AdminAboutUs /></RequireAdmin>} /> 
          <Route path="/admin/settings/team" element={<RequireAdmin><AdminTeam /></RequireAdmin>} /> 
          <Route path="/admin/crm/testimonials" element={<RequireAdmin><AdminTestimonials /></RequireAdmin>} />  
          <Route path="/admin/settings/social" element={<RequireAdmin><AdminSocialLinks /></RequireAdmin>} />  
          <Route path="/admin/settings/users" element={<RequireAdmin><AdminUsers /></RequireAdmin>} />  
          <Route path="/admin/settings/logos" element={<RequireAdmin><AdminLogos /></RequireAdmin>} />  
          <Route path="/admin/crm/wishlist" element={<RequireAdmin><AdminCustomerWishlist /></RequireAdmin>} /> 
          <Route path="/admin"               element={<Navigate to="/admin/dashboard" replace />} />

        </Routes>
      </ShopProvider>
    </BrowserRouter>
  );
}